<template>
  <DialogTemplate
    style="min-width: clamp(1px, 48rem, 100vw); min-height: 0"
    data-gwmenu="noclose"
  >
    <!-- data-gwmenu="noclose" -->
    <!-- <SolfigrSaveTree
      :namespace="namespace"
      class="save-preset-form"
      ref="form"
    /> -->

    <!-- SolfigrSavedTreesDialog -->
    <div
      class="f-column w-100"
      style="min-height: 0; max-height: 42.5rem; height: 100vh"
    >
      <SavedTreesTableV1
        :key="'will'"
        :namespace="namespace"
        :hasOverwrite="hasOverwrite"
        :hasPresetModes="!hasOverwrite"
        class="flex-1 mt-2"
        @apply:tree="applyTree"
      >
        <template #title>
          <div class="text-normal-large weight_600 text-nowrap mr-2">
            {{ $t('data_table.saved_trees.title_tra01') }}
          </div>
        </template>
      </SavedTreesTableV1>
    </div>

    <template #dialog_actions>
      <LinkGuide
        v-if="!$i18n.g1"
        class="my-auto"
        :link="links_url_links.saving_loading_guides.url"
        :text="links_url_links.saving_loading_guides.text"
        @click.stop
      />
      <v-btn
        id="trainer-settings-btn-close"
        variant="text"
        class="ml-auto mr-2"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import LinkGuide from '@/components/AppBar/LinkGuide'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
// import SolfigrSaveTree from '@/components/Dialogs/Solfigr/SolfigrSaveTree'
import { SNK } from '@/helpers/helpers'
import SavedTreesTableV1 from '@/components/DataTables/v2/tables/SavedTreesTableV1/SavedTreesTableV1'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'SolfigrSavedTreesDialog',
  components: {
    SavedTreesTableV1,
    LinkGuide,
    DialogTemplate,
  },
  mixins: [links_mix],
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    applyTree({ item, solfigrPresetMode = 'restoreall' }) {
      // this.$store.commit(`${this.namespace}/gamestate_set`, {
      //   key: 'history_spots',
      //   value: [],
      // })
      // if (solfigrPresetMode === 'restoreall') {
      //   this.$store.commit(`${this.namespace}/slfrm_reset`)
      // }

      this.$store.dispatch('api_poker_custom_user_trees', {
        id: item.id,
        action: SNK('slfrm_applyApiPreset', this.namespace),
        actionArgs: {
          solfigrPresetMode,
        },
      })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-saved-trees-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    hasOverwrite() {
      return this.dialog.mode === 'overwrite'
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .save-preset-form {
    margin-top: 1.5rem;
  }
}
</style>
